import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubbleWideNotification: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconBubbleWideNotification"><Path fillRule="evenodd" clipRule="evenodd" d="M19 2C16.7909 2 15 3.79086 15 6C15 8.20914 16.7909 10 19 10C21.2091 10 23 8.20914 23 6C23 3.79086 21.2091 2 19 2Z" fill="currentColor"/><Path d="M13.4375 6C13.4375 4.89517 13.7596 3.86558 14.315 3H2V19H8.74274L11.9951 21.7263L15.2858 19H22V10.685C21.1344 11.2404 20.1048 11.5625 19 11.5625C15.9279 11.5625 13.4375 9.07208 13.4375 6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubbleWideNotification;
